<template>
  <div>
    <v-radio-group @change="onChange" v-model="pd" :mandatory="false">
        <v-radio  color="primary" v-for="d in items" :label="d.Label" :value="d.Value" v-bind:key="d.Value" /> 
    </v-radio-group>
  </div>
</template>

<script>
import dataSvc from "@/services/dataService";
export default {
  props: ["menucode", "value"],
  data() {
    return {
      items: [],
      pd: null
    };
  },
  mounted() {
    dataSvc
      .loadDD(this.menucode)
      .then(res => {
        this.items = res;
      });
       
  },
  methods:{
      onChange(){          
          this.$emit('input', this.pd);
      }
  },
  watch:{
    value(n){      
      this.pd = n;
    }
  }
};
</script>
